exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-logo__headerLogo___3mn2b {\n  background: url(" + require("./logo.png") + ") no-repeat;\n  background-size: contain;\n  text-indent: -9999px;\n  width: 250px;\n  height: 70px;\n  background-position: center; }\n", ""]);

// exports
exports.locals = {
	"headerLogo": "header-logo__headerLogo___3mn2b"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Logos/HeaderLogo/header-logo.scss
// module id = 896
// module chunks = 0